import { useRef } from 'react';

// Gives every function in `actions` one identity for the life of the component: each
// stable function calls the latest version it was handed. The Studio's action closures
// are rebuilt on every render; through this, a memoized child (memoStudio) can list them
// as dependencies without re-rendering every time, and still call the current one.
export default function useStableActions(actions) {
  const latest = useRef(actions);
  latest.current = actions;
  const stable = useRef({});
  for (const name of Object.keys(actions)) {
    if (!stable.current[name]) stable.current[name] = (...args) => latest.current[name](...args);
  }
  return stable.current;
}
